export function isIOSBrowser(): boolean {
    return (
        navigator.userAgent.indexOf("iPad") > -1 ||
        navigator.userAgent.indexOf("iPhone") > -1 ||
        navigator.userAgent.indexOf("iPod") > -1
    );
}